import React, { useState } from 'react';
import { get, includes, map } from 'lodash';
import { func, object, string, array, bool } from 'prop-types';
import { withNavigation } from '../../../hoc';
import {
    Card,
    Column,
    Row,
    Button,
    StatusTag,
    HasPermissions,
    Link,
    Text,
    Icon,
    SlaIcon,
    OrderShippingEstimate,
    If,
    FlexContainer
} from '../../common';
import OrderCardBody from './OrderCardBody';
import FormPOS from '../FormPOS';
import { cleanOrderId } from '../../../utils/misc';
import { Modal } from 'antd';

const OrderCard = ({ data, navigate, width, onPickerModalOpen, newOrders, pendingOrdersAlert, ...props }) => {
    const [visible, setVisible] = useState(false);
    const [disabledPrintButtons, setDisabledPrintButtons] = useState([]);
    const orderId = get(data, 'id');
    const selectedSla = get(data, 'logisticsInfo.selectedSla', null);
    const status = get(data, 'assignInfo.status.label', 'no importado');
    const renderPOS = ['4'].includes(get(data, 'assignInfo.status.code', '0'));

    const showModal = () => {
        setVisible(true);
        disablePrintButton();
    };

    const handleCancel = () => setVisible(false);

    const disablePrintButton = () => {
        switch (status) {
            case 'available':
            case 'in_picking':
            case 'paused':
                setDisabledPrintButtons(['dispatch', 'order', 'orderLabels']);
                break;
            case 'pickeo_for_invoicing':
                setDisabledPrintButtons([]);
                break;
        }
    };

    const documents = [
        { text: 'Control Interno', key: 'orderList', path: `order-list` },
        { text: 'Hoja de despacho', key: 'dispatch', path: `order-pdf` },
        { text: 'Hoja de Pedido', key: 'order', path: `dispatch-pdf` },
        { text: 'Etiquetas', key: 'orderLabels', path: `order-labels` }
    ];

    const ModalContent = () => {
        return (
            <Column padding={8}>
                <Row padding='10px 6px' borderBottom='1px solid #e8e8e8' justify='space-between'>
                    <Text text='Pedido' strong size={18} />
                    <Text text={cleanOrderId(orderId)} strong color='#1fa02e' size={18} />
                </Row>
                { map(documents, ({ text, key, path }) => {
                    const isDisabled = includes(disabledPrintButtons, key);
                    return (
                        <Row key={key} padding='10px 6px' borderBottom='1px solid #e8e8e8' justify='space-between'>
                            <Row justify='flex-start' align='center'>
                                <Icon name='clipboard' size='19' color='#333333' />
                                <Text paddingLeft={10} text={text} strong />
                            </Row>
                            <Icon
                                pointer={!isDisabled}
                                name='printer'
                                size='19'
                                color={isDisabled ? '#333333' : '#a4c735'}
                                onClick={() => !isDisabled && window.open(`/${path}/${orderId}`, '_blank')}
                            />
                        </Row>
                    );
                }) }
            </Column>
        );
    };

    return (
        <Row
            width={width}
            flex='1 0 280px'
            maxWidth={360}
            minWidth='18%'
            boxShadow
        >
            <OrderShippingEstimate {...data}>
                {({ isDelayed, deliveryTimeHour }) => (
                    <Card
                        style={{
                            borderTop: pendingOrdersAlert ? `9px solid #${includes(newOrders, orderId) ? '1fa02e' : 'C0C0C0'}` : ''
                        }}
                        noHeaderDivider
                        {...props}
                        fullHeader={isDelayed}
                        leftHeader={() => (
                            <Column justify='center'>
                                <FlexContainer align='center'>
                                    <SlaIcon sla={selectedSla} />
                                    <FlexContainer justify='space-between' flex={1}>
                                        <Column>
                                            <Link
                                                text={cleanOrderId(orderId)}
                                                src={`/orders/${orderId}`}
                                                align='center'
                                                size={14}
                                                color='#1fa02e'
                                                bold
                                            />
                                            <Text semibold text={selectedSla} />
                                        </Column>
                                        <Column justify='center' noFlex>
                                            <StatusTag status={`order_status.${status}`} style={{ margin: 0 }} tagType={status} />
                                        </Column>
                                    </FlexContainer>
                                </FlexContainer>
                            </Column>
                        )}
                        bodyChildren={() => <OrderCardBody onPickerModalOpen={onPickerModalOpen} data={data} isDelayed={isDelayed} text={deliveryTimeHour} />}
                        footerChildren={() => (
                            <FlexContainer justify={renderPOS ? 'space-between' : 'center'} flex={1}>
                                <HasPermissions to={['orders-pending-page:print']}>
                                    <Button type='primary' text='Imprimir' secondary fitContent onClick={showModal} />
                                    <Modal
                                        title='Imprimir Documento'
                                        visible={visible}
                                        width='400px'
                                        height='315.2px'
                                        onCancel={handleCancel}
                                        footer={null}
                                    >
                                        <ModalContent />
                                    </Modal>
                                </HasPermissions>
                                <If
                                    condition={renderPOS}
                                    then={<FormPOS data={data} condition={renderPOS} title='POS' buttonType={{ primary: true, width: 85 }} />}
                                />
                            </FlexContainer>
                        )}
                    />
                )}
            </OrderShippingEstimate>
        </Row>
    );
};

OrderCard.defaultProps = {
    width: ['100%', '50%', '18%'],
    onPickerModalOpen: () => (null)
};

OrderCard.propTypes = {
    navigate: func,
    data: object,
    text: string,
    width: array,
    onPickerModalOpen: func,
    newOrders: array,
    pendingOrdersAlert: bool
};

export default withNavigation(OrderCard);
